import { AtomIcon } from "lucide-react";

export const Logo = (props: React.ComponentProps<typeof AtomIcon>) => {
	return <AtomIcon {...props} />;
};
